<template>
  <!-- eslint-disable -->
  <SnackBar ref="snackbar" />
  <div class="flex-title">
    <v-btn
      style="background: #f9f8f8; font-size: 18px"
      size="small"
      @click="this.$router.go(-1)"
      icon
    >
      <v-icon color="#004984">mdi-arrow-left</v-icon>
    </v-btn>
    <v-skeleton-loader
      class="skeleton-wrapper sprint-text"
      type="text"
      :loading="isLoading"
      v-if="isLoading"
    ></v-skeleton-loader>
    <h1 class="sprint-text" v-else>
      {{ tituloSprint }}
    </h1>
  </div>
  <div class="flex justify-center">
    <div class="min-height flex overflow-x-scroll ml-4">
      <div
        v-for="column in columns"
        :key="column.status"
        class="bg-gray-100 rounded-lg px-3 py-3 column-width rounded mr-4"
      >
        <p
          class="text-black font-semibold font-sans tracking-wide text-sm"
          style="font-size: 16px"
        >
          {{ column.status }}
        </p>
        <v-skeleton-loader
          class="skeleton-task-card"
          type="card-avatar"
          :loading="isLoading"
          v-if="isLoading"
        >
        </v-skeleton-loader>
        <draggable
          :list="column.tasks"
          :animation="200"
          ghost-class="ghost-card"
          group="tasks"
          @change="changeEvent"
          itemKey="id"
          v-else
        >
          <template #item="{ element, index }">
            <div class="mt-3 cursor-move">
              <task-card
                :key="column.tasks[index].id"
                :task="column.tasks[index]"
                @click="redirectToTask(element)"
              ></task-card>
            </div>
          </template>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import draggable from 'vuedraggable';
import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader';

import SnackBar from '@/components/SnackBar.vue';
import TaskCard from '@/components/TaskCard.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL

export default {
  components: {
    TaskCard,
    draggable,
    VSkeletonLoader,
    SnackBar,
  },
  data() {
    return {
      columns: [
        {
          status: 'A Fazer',
          tasks: [],
        },
        {
          status: 'Em Desenvolvimento',
          tasks: [],
        },
        {
          status: 'Testando',
          tasks: [],
        },
        {
          status: 'Em Revisão',
          tasks: [],
        },
        {
          status: 'Impedido',
          tasks: [],
        },
        {
          status: 'Finalizado',
          tasks: [],
        },
      ],
      numeroSprint: '',
      tituloSprint: '',
      isLoading: true,
      idSprint: this.$route.params.id,
    };
  },

  created() {
    this.fetchTasks();
    this.fetchSprint();
  },

  methods: {
    changeEvent: function (evt) {
      if (evt.added && evt.added.element) {
        // Nova coluna (novo status)
        const newColumn = this.columns.find((column) =>
          column.tasks.includes(evt.added.element),
        );
        // const idSprint = this.$route.params.id;
        console.log(this.idSprint);

        // Filtra pelo itemBacklog correspondente àquele idSprint em questao
        const itemBacklogSprint = evt.added.element.tb_itembacklogsprint.find(
          (item) => item.id_sprint === this.idSprint,
        );

        if (itemBacklogSprint) {
          const idTarefa = evt.added.element.id_tarefa;
          const idBacklogSprint = itemBacklogSprint.id_item_backlog_sprint;
          const statusTarefa = newColumn.key;
          console.log(`Task ${idTarefa} -> ${statusTarefa}`);
          console.log(
            `id_item_backlog_sprint: ${itemBacklogSprint.id_item_backlog_sprint}`,
          );
          this.setTask(idBacklogSprint, statusTarefa);
        }
      }
    },
    handleClick(idTarefa) {
      console.log(`Clicou na tarefa ${idTarefa}`);
    },
    redirectToTask(task) {
      console.log(task);
      this.$router.push({
        name: 'sprints/backlog/tarefa',
        params: {
          id: parseInt(this.$route.params.id),
          idTarefa: parseInt(task.id_tarefa),
        },
      });
    },
    fetchTasks() {
      axios
        .get(API_URL + `/sprints/backlog/${this.$route.params.id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          // console.log(response);
          // console.log(this.idSprint);
          const tasks = response.data;

          const columns = [
            {
              status: 'A Fazer',
              tasks: tasks.filter((task) =>
                task.tb_itembacklogsprint.some(
                  (item) =>
                    item.id_sprint === this.idSprint &&
                    item.status_item_sprint === 'A_FAZER',
                ),
              ),
              key: 'A_FAZER',
            },
            {
              status: 'Em Desenvolvimento',
              tasks: tasks.filter((task) =>
                task.tb_itembacklogsprint.some(
                  (item) =>
                    item.id_sprint === this.idSprint &&
                    item.status_item_sprint === 'EM_DESENVOLVIMENTO',
                ),
              ),
              key: 'EM_DESENVOLVIMENTO',
            },
            {
              status: 'Testando',
              tasks: tasks.filter((task) =>
                task.tb_itembacklogsprint.some(
                  (item) =>
                    item.id_sprint === this.idSprint &&
                    item.status_item_sprint === 'TESTANDO',
                ),
              ),
              key: 'TESTANDO',
            },
            {
              status: 'Em Revisão',
              tasks: tasks.filter((task) =>
                task.tb_itembacklogsprint.some(
                  (item) =>
                    item.id_sprint === this.idSprint &&
                    item.status_item_sprint === 'EM_REVISAO',
                ),
              ),
              key: 'EM_REVISAO',
            },
            {
              status: 'Impedido',
              tasks: tasks.filter((task) =>
                task.tb_itembacklogsprint.some(
                  (item) =>
                    item.id_sprint === this.idSprint &&
                    item.status_item_sprint === 'IMPEDIDO',
                ),
              ),
              key: 'IMPEDIDO',
            },
            {
              status: 'Finalizado',
              tasks: tasks.filter((task) =>
                task.tb_itembacklogsprint.some(
                  (item) =>
                    item.id_sprint === this.idSprint &&
                    item.status_item_sprint === 'FINALIZADO',
                ),
              ),
              key: 'FINALIZADO',
            },
          ];

          this.columns = columns;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    setTask(idBacklogSprint, statusTarefa) {
      axios
        .patch(
          API_URL + `/tarefas/status/${idBacklogSprint}`,
          {
            status: statusTarefa,
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        )
        .then(() => {
          // console.log(response.data);
        })
        .catch(() => {
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Você não tem autorização para essa ação!',
          );
          setTimeout(() => {
            this.fetchTasks();
          }, 3000);
        });
    },
    fetchSprint() {
      axios
        .get(API_URL + `/sprints/${this.$route.params.id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.numeroSprint = response.data.numero_sprint;
          this.tituloSprint = response.data.titulomilestone;
          this.isLoading = false;
          console.log(this.numeroSprint);
          console.log(this.tituloSprint);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
@import 'tailwindcss/base';
@import 'tailwindcss/components';
@import 'tailwindcss/utilities';
.column-width {
  min-width: 320px;
  width: 320px;
}
.column-width > div {
  min-height: 100%;
}
.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.sprint-text {
  font-size: 22px;
  font-weight: bold;
}
.skeleton-wrapper {
  width: 50%;
  background: transparent;
}
.skeleton-task-card {
  margin-top: 20px;
  min-height: auto !important;
}
.flex-title {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
}
.min-height {
  min-height: 85vh;
}
</style>
